<template>
  <div class="risk-check-management">
    <el-row :gutter="20" class="stats-row">
      <el-col :span="8">
        <el-card shadow="hover">
          <div class="stat-title">累计拦截</div>
          <div class="stat-value danger">{{ stats.totalBlocked || 0 }}</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover">
          <div class="stat-title">今日拦截</div>
          <div class="stat-value warning">{{ stats.todayBlocked || 0 }}</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover">
          <div class="stat-title">累计检查</div>
          <div class="stat-value">{{ stats.totalChecked || 0 }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div slot="header" class="card-header">
        <span>登录风控日志</span>
        <el-button type="primary" icon="el-icon-refresh" size="mini" @click="refreshAll">刷新</el-button>
      </div>

      <div class="filter-bar">
        <el-input
          v-model="searchUsername"
          placeholder="搜索用户名/手机号"
          clearable
          style="width: 220px; margin-right: 10px;"
          @keyup.enter.native="handleSearch"
        />
        <el-select v-model="passedFilter" placeholder="检查结果" clearable style="width: 140px; margin-right: 10px;">
          <el-option label="已拦截" :value="0" />
          <el-option label="已通过" :value="1" />
        </el-select>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 260px; margin-right: 10px;"
          @change="handleSearch"
        />
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      </div>

      <el-table
        :data="logs"
        border
        stripe
        v-loading="loading"
        element-loading-text="正在加载风控日志..."
      >
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column prop="username" label="用户" min-width="130" show-overflow-tooltip />
        <el-table-column prop="passed" label="结果" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.passed === 1 ? 'success' : 'danger'" size="mini">
              {{ scope.row.passed === 1 ? '通过' : '拦截' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="reasonMessage" label="封控原因" min-width="220" show-overflow-tooltip />
        <el-table-column prop="tags" label="风险标签" min-width="180" show-overflow-tooltip />
        <el-table-column prop="aliDeviceId" label="设备ID" min-width="160" show-overflow-tooltip />
        <el-table-column prop="ipAddress" label="IP" width="130" show-overflow-tooltip />
        <el-table-column prop="createdAt" label="检查时间" width="180" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createdAt) }}
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { request } from '@/utils/http'

export default {
  name: 'RiskCheckManagement',
  data() {
    return {
      stats: {},
      logs: [],
      loading: false,
      searchUsername: '',
      passedFilter: null,
      dateRange: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted() {
    this.refreshAll()
  },
  methods: {
    async refreshAll() {
      await Promise.all([this.fetchStats(), this.fetchLogs()])
    },
    async fetchStats() {
      try {
        const response = await request('/admin/risk/stats')
        this.stats = response.data || {}
      } catch (error) {
        this.$message.error(error.message || '获取风控统计失败')
      }
    },
    async fetchLogs() {
      this.loading = true
      try {
        const params = new URLSearchParams()
        params.append('pageNum', this.pagination.pageNum)
        params.append('pageSize', this.pagination.pageSize)
        if (this.searchUsername) {
          params.append('username', this.searchUsername)
        }
        if (this.passedFilter !== null && this.passedFilter !== '') {
          params.append('passed', this.passedFilter)
        }
        if (this.dateRange && this.dateRange.length === 2) {
          params.append('startDate', this.dateRange[0])
          params.append('endDate', this.dateRange[1])
        }
        const response = await request(`/admin/risk/logs?${params.toString()}`)
        this.logs = response.data.records || []
        this.pagination.total = response.data.total || 0
      } catch (error) {
        this.$message.error(error.message || '获取风控日志失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.fetchLogs()
    },
    handleCurrentChange(pageNum) {
      this.pagination.pageNum = pageNum
      this.fetchLogs()
    },
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageNum = 1
      this.fetchLogs()
    },
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.risk-check-management {
  padding: 20px;
}

.stats-row {
  margin-bottom: 20px;
}

.stat-title {
  color: #909399;
  font-size: 14px;
}

.stat-value {
  margin-top: 8px;
  font-size: 28px;
  font-weight: bold;
  color: #303133;
}

.stat-value.danger {
  color: #f56c6c;
}

.stat-value.warning {
  color: #e6a23c;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.filter-bar {
  margin-bottom: 16px;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
